import React from 'react';
import { Hero } from './components/Hero';
import { Vision } from './components/Vision';
import { IsItForYou } from './components/IsItForYou';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="w-full min-h-screen bg-brand-bg font-sans text-brand-text" data-id="element-0">
      <Hero data-id="element-1" />
      <Vision data-id="element-2" />
      <IsItForYou data-id="element-3" />
      <Volumes data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />

      {/* Footer / Final Quote */}
      <footer className="py-16 px-4 text-center bg-brand-sageDark text-white" data-id="element-7">
        <div className="max-w-3xl mx-auto" data-id="element-8">
          <p className="text-2xl md:text-3xl font-serif italic font-medium leading-relaxed" data-id="element-9">
            "Tu hijo no necesita padres perfectos.
            <br data-id="element-10" />
            <span className="text-brand-peach" data-id="element-11">
              Necesita padres que estén dispuestos a aprender.
            </span>
            "
          </p>
        </div>
      </footer>
    </div>;
}